import React from 'react'
import PropTypes from 'prop-types'
import NextLink from 'next/link'

import { routes } from 'src/constants/routes'
import { LinkBase } from './styles'

const Link = ({ page, children, onClick, query = {}, target = '', rel = '' }) => {
  if (!page) {
    return children
  }

  function handleClick() {
    if (onClick) onClick()
  }

  function handleKeyPress(event) {
    if (event.key === 'Enter') {
      handleClick()
    }
  }

  return (
    <NextLink href={{ pathname: routes[page].pathname, query }} passHref>
      <LinkBase
        role="link"
        tabIndex={0}
        onClick={handleClick}
        onKeyPress={handleKeyPress}
        target={target}
        rel={rel}
      >
        {children}
      </LinkBase>
    </NextLink>
  )
}

Link.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  page: PropTypes.string.isRequired,
  query: PropTypes.objectOf(PropTypes.string),
  target: PropTypes.string,
  rel: PropTypes.string,
}

export default Link
